import http from "./http.js";


async function download(location, params) {
  if (params) {
    try {
      const response = await http.post(location, params, { responseType: "blob", contentType: "application/json" });
      return window.URL.createObjectURL(new Blob([response.data]));
    } catch (err) {
      throw err;
    }
  } else {
    try {
      const res = await http.get(location, { responseType: "blob" });
      return window.URL.createObjectURL(new Blob([res.data]));
    } catch (err) {
      throw err;
    }
  }
}

export { download };
